/*LIBRARY*/
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import centroid from "@turf/centroid";
import { ArrowBackIos, Close } from "@material-ui/icons";
import { featureCollection } from "@turf/helpers";
import bbox from "@turf/bbox";

/*COMPONENT*/
import SolidCheckbox from "../reuseable/SolidCheckbox";
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*REDUX*/
import {
  set_value_toolbox,
  toolbox_handle_back,
} from "../../App/actions/toolboxActions";

/*PICTURE*/
import icon_trash from "../../Assets/svg/icon_trash.svg";

/*FUNCTION*/

/*HOOKS */
import useLanguage from "../common_hooks/useLanguage";
import Modal from "../common_modal/Modal";
import { array_to_sentence, parseRichText } from "../../App/validation/text_helper";
import {
  generateField,
  select_field_from_default_props,
} from "../../App/validation/generateGeoJson";
import {
  toolbox_save_layer,
  push_features,
} from "../../App/actions/layerNewActions";
import { Dropdown } from "../reuseable";
import POI_SELECTOR from "../reuseable/POI_SELECTOR";
import { format_time } from "../../App/validation/count_day_left";
import { post_activities } from "../../App/actions/activities";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*CONST*/

function TOOLBOX_DETAIL_ROUTING() {
  // hooks
  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  // global props
  const { map_object, geo_layer_list } = useSelector((state) => state.layer) || {};
  const point_layers = geo_layer_list.filter(l => l.geo_layer.type === "Point");
  const toolbox = useSelector((state) => state.toolbox) || {};
  const auth = useSelector((state) => state.auth) || {};
  const { geo_project } = useSelector((state) => state.project) || {};
  const {
    mode_toolbox,
    uuid_name,
    routing_active_uuid,
    last_saved_feature_uuid,
    source_tab,
    selected_poi_types,
    features_routing_obj,
    start_time,
  } = toolbox || {};

  // naming
  const visible_name = mode_toolbox.replace("features", "visible");  // visible_radius
  const fields_toolbox = mode_toolbox.replace("features", "fields"); // fields_radius
  const source_id_line = "geojson_routing_line";
  const source_id_point = "geojson_routing_point";

  const visible_features = toolbox?.[visible_name];

  const fields = toolbox[fields_toolbox];
  const features = []

  toolbox?.features_routing_obj?.order?.forEach(uuid => {
    if (features_routing_obj?.data?.[uuid]?.lineString)
      features.push(features_routing_obj?.data?.[uuid]?.lineString);
  })

  const selected_row_toolbox_ids = toolbox[uuid_name];
  const selected_all =
    selected_row_toolbox_ids.length > 0
      ? !features.some((f) => !selected_row_toolbox_ids.includes(f.properties.uuid))
      : false;

  let last_saved_feature_uuid_index;
  if (last_saved_feature_uuid === "") last_saved_feature_uuid_index = Infinity;
  else if (last_saved_feature_uuid === "start") last_saved_feature_uuid_index = -1;
  else {
    // partial save
    last_saved_feature_uuid_index = features.findIndex(
      f => f.properties.uuid === last_saved_feature_uuid
    );
  }

  // local state
  const [layer_ids, set_layer_ids] = useState([]);
  const [modal_delete, set_modal_delete] = useState(false);
  const [modal_save_tool, set_modal_save_tool] = useState(false);
  const [new_layer_name, set_new_layer_name] = useState("");
  const [modal_mapid_data, set_modal_mapid_data] = useState(false);
  const selected_layers = geo_layer_list.filter(l => layer_ids.includes(l.geo_layer._id))


  // functions
  const on_clear_select = () => {
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    const will_be_change_style = features.filter((f) =>
      visible_features.includes(f.properties.uuid),
    );
    if (!map_object) return;

    will_be_change_style.forEach((f) => {
      map_object.setFeatureState(
        { source: source_id_line, id: f.properties.uuid },
        { selected: false },
      );
    });
  };

  const on_select_row_uuid = async (uuid) => {
    const selected_row_toolbox_ids = toolbox[uuid_name];
    const willBeSelected = !selected_row_toolbox_ids.includes(uuid);

    // Update Redux
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: willBeSelected
          ? [...selected_row_toolbox_ids, uuid]
          : selected_row_toolbox_ids.filter((id) => id !== uuid),
      }),
    );

    // Set feature state sesuai state yang BARU
    map_object.setFeatureState(
      { source: source_id_line, id: uuid },
      { selected: willBeSelected }, // ✅ Langsung pake nilai baru
    );
  };

  const fly_to = (uuid) => {
    const feature = features_routing_obj?.data?.[uuid]?.lineString;
    if (uuid && feature?.geometry) {
      const geojson = featureCollection([feature]);
      const feature_center = centroid(geojson);
      const longitude = feature_center?.geometry?.coordinates?.[0];
      const latitude = feature_center?.geometry?.coordinates?.[1];
      if (map_object && longitude && latitude) {
        const bounds = bbox(geojson);
        map_object.flyTo({
          center: [longitude, latitude],
          speed: 1,
          zoom: map_object.cameraForBounds([
            [bounds[0], bounds[1]],
            [bounds[2], bounds[3]]
          ]).zoom
        });
      }
    }
  };

  const on_hide = (uuid) => {
    let visible_features = [...toolbox?.[visible_name]];
    if (visible_features.includes(uuid)) {
      visible_features = visible_features.filter((item) => item !== uuid);
    } else {
      visible_features.push(uuid);
    }

    if (!map_object) return;

    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: visible_features,
      }),
    );

    // line
    map_object.getSource(source_id_line)?.setData(
      featureCollection(
        features.filter((item) =>
          visible_features.includes(item.properties.uuid),
        )
      )
    );

    const features_points = [];
    toolbox?.features_routing_obj?.order?.forEach(uuid => {
      if (features_routing_obj?.data?.[uuid]?.point && visible_features.includes(uuid))
        features_points.push(...features_routing_obj?.data?.[uuid]?.point);
    })

    // point
    map_object.getSource(source_id_point)?.setData(
      featureCollection(features_points)
    );

    // label
    // features.forEach((feature) => {
    //   if (visible_features.includes(feature.properties.uuid)) {
    //     create_marker_element({
    //       feature,
    //       uuid_active: feature.properties.uuid,
    //       map_object,
    //     });
    //   } else {
    //     const marker_to_remove = document.getElementById(
    //       `marker_toolbox_${uuid}`,
    //     );
    //     if (marker_to_remove) {
    //       marker_to_remove.remove();
    //     }
    //   }
    // });
  };

  const on_delete = () => {

    let new_features_line = [];
    let new_features_point = [];
    let new_data = {};
    let new_order = [];
    let new_last = [];
    features_routing_obj?.order.forEach((uuid, idx) => {
      if (!selected_row_toolbox_ids.includes(uuid)) {
        new_order.push(uuid);
        new_data[uuid] = features_routing_obj?.data[uuid];
        new_features_line.push(features_routing_obj?.data[uuid]?.lineString);
        new_features_point.push(...features_routing_obj?.data[uuid]?.point);
        if (last_saved_feature_uuid_index > idx) new_last.push(features_routing_obj?.data[uuid]?.lineString);
      }
    })
    let new_last_uuid = new_last?.at(-1)?.properties?.uuid;
    if (new_last.length === 0) {
      new_last_uuid = "start";
    }

    const new_features_routing_obj = {
      order: new_order,
      data: new_data
    };

    const new_visibles = visible_features.filter(
      (uuid) => !selected_row_toolbox_ids.includes(uuid),
    );

    // update yang di mapnya
    if (!map_object) return;

    // set features yang terlihat (dishow)
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: new_visibles,
      }),
    );


    dispatch(
      set_value_toolbox({
        key: "features_routing_obj",
        value: new_features_routing_obj,
      }),
    );

    if (map_object?.getSource(source_id_line))
      map_object.getSource(source_id_line)?.setData(
        featureCollection(new_features_line)
      );

    if (map_object?.getSource(source_id_point))
      map_object.getSource(source_id_point)?.setData(
        featureCollection(new_features_point)
      );


    // set feature yang diselect
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    dispatch(
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: new_last_uuid,
      }),
    );

    set_modal_delete(false);
  };

  const on_hide_all = () => {
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: [],
      }),
    );

    // hapus line dari map
    if (map_object?.getSource(source_id_line)) {
      const geojson_polygon = featureCollection([])
      map_object.getSource(source_id_line)?.setData(geojson_polygon);
    }

    // hapus titik-titik elevasi
    if (map_object?.getSource(source_id_point)) {
      const geojson_polygon = featureCollection([])
      map_object.getSource(source_id_point)?.setData(geojson_polygon);
    }
  }

  const on_save = async () => {

    const properties = select_field_from_default_props("LineString");
    const field_names_will_be_saved = [
      {
        name: "id_tool",
        type: "text",
      },
      {
        name: "duration_sec",
        type: "number",
      },
      {
        name: "distance_m",
        type: "number",
      },
    ];

    const new_fields = [
      ...properties.concat(
        field_names_will_be_saved.map((i) => generateField(i.name, i.type, false))
      )
    ];

    const body = {
      name: new_layer_name || "New Layer",
      description: "",
      type: "LineString",
      folder: "",
      user_id: auth?.user?._id,
      geo_project_id: geo_project._id,
      fields: new_fields,
      properties,
      status: "digitasi",
      architecture: "v2",
      label_config: {
        is_use_label_text: true,
        is_use_label_image: false,
        label_text_field_key_array: [
          "id_tool"
        ],
        label_image_field_key_array: [],
        style_mode: "style_1",
        background_color_primary: "rgba(11, 217, 130, 1)",
        outline_color_primary: "rgba(0,0,0,0)",
        text_color_primary: "rgba(255, 255, 255, 1)",
        is_use_pin: false,
        text_stroke_width: 0,
        text_stroke_color: "rgba(255,255,255,1)",
        font_size: 11,
        font_weight: "bold",
        pin_height: 25
      },
    };

    let geo_layer = await dispatch(toolbox_save_layer(body));
    if (!geo_layer) return;

    const features_will_save = features
      .filter((f) => selected_row_toolbox_ids.includes(f.properties.uuid))
      .map((f) => {
        let new_properties = {};
        new_fields.forEach((i) => {
          new_properties[i.key] = f.properties[i.name]
        });

        return {
          ...f,
          properties: new_properties
        }

      });

    await dispatch(
      push_features({
        geo_layer_id: geo_layer?._id,
        features: features_will_save,
      }),
    );

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (start_time) await dispatch(post_activities({ action: `toolbox-${toolbox_type}-save`, duration_ms: new Date() - start_time }));

    set_modal_save_tool(false);
    set_new_layer_name("");

    on_clear_select();
    on_hide_all();

    const body_get = {
      geo_layer_id: geo_layer?._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      geo_layer_item: geo_layer,
    };
    dispatch(getDetailLayerById(body_get));
  };

  const on_select_all = () => {
    if (!selected_all) {
      const will_be_selected = features.map((f) => f.properties.uuid);
      dispatch(
        set_value_toolbox({
          key: uuid_name,
          value: will_be_selected,
        }),
      );

      const will_be_change_style = features.filter((f) =>
        visible_features.includes(f.properties.uuid),
      );
      if (!map_object) return;

      will_be_change_style.forEach((f) => {
        map_object.setFeatureState(
          { source: source_id_line, id: f.properties.uuid },
          { selected: true },
        );
      });
    } else {
      on_clear_select();
    }
  };

  const on_back = (value) => {
    dispatch(toolbox_handle_back());
  }

  const enter_id = (id) => {
    if (layer_ids.includes(id)) {
      set_layer_ids(layer_ids.filter(i => i !== id))
    } else {
      set_layer_ids([...layer_ids, id])
    }
  }

  const set_selected_poi_types = (value) => {
    dispatch(set_value_toolbox({
      key: "selected_poi_types",
      value: value
    }));
  }

  const deleted_list = features.reduce(function (result, feature) {
    if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
      return result.concat(feature.properties.id_tool);
    }
    return result;
  }, []);

  // content
  const modal_delete_content = modal_delete && (
    <Modal
      isOpen={modal_delete}
      onClose={() => set_modal_delete(false)}
      modalSize="small"
      title="Confirmation"
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px", maxHeight: "400px", overflowY: "auto" }}>
        <p style={{ display: "inline" }}>{dict["Are you sure to delete"][language]}{` `}</p>
        <p style={{ display: "inline", fontWeight: 700, fontSize: "18px" }}>
          {deleted_list && array_to_sentence(deleted_list, "eng")}
        </p>
        <p style={{ display: "inline" }}>{`?`}</p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "15px",
        }}
      >
        <button
          onClick={() => set_modal_delete(false)}
          className="button_pill button_white"
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_delete()}
          className="button_pill flex"
          style={{
            backgroundColor: "#BD0000",
            color: "white",
          }}
        >
          <img src={icon_trash} alt="Delete" />
          {dict["Delete"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_save_content = modal_save_tool && (
    <Modal
      isOpen={modal_save_tool}
      onClose={() => set_modal_save_tool(false)}
      modalSize="small"
      title={dict["Give a name"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px" }}>
        <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
          {dict["Layer Name"][language]}
        </p>
      </div>

      <div style={{ marginBottom: "25px" }}>
        <input
          type="text"
          style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
          value={new_layer_name}
          onChange={(e) => set_new_layer_name(e.target.value)}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          onClick={() => set_modal_save_tool(false)}
          className="button_pill flex"
          style={{
            border: "1px solid black",
            color: "black",
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => on_save()}
          className="button_pill flex"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          Save
        </button>
      </div>
    </Modal>
  );

  const modal_mapid_data_content = modal_mapid_data && (
    <Modal
      isOpen={modal_mapid_data}
      onClose={() => set_modal_mapid_data(false)}
      modalSize="small"
      title={"Select MAPID Data"}
      is_hide="hide"
    >

      <POI_SELECTOR
        get_value={set_selected_poi_types}
        selected_poi_types={selected_poi_types}
      />
    </Modal>
  );

  const on_edit = (uuid) => {
    dispatch(set_value_toolbox({ key: "routing_active_uuid", value: uuid }));
  }

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 20px 25px 20px",
        }}
      >
        <button
          onClick={() => on_back(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: 700,
            width: "fit-content",
            padding: "2px 10px",
            borderRadius: "2px",
          }}
        >
          <ArrowBackIos style={{ fontSize: "12px" }} />
          {dict["Back to Menu"][language]}
        </button>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "0 27px"
        }}
      >

        {source_tab === 1 &&
          <>
            <div
              style={{
                border: "1px solid #D3B572",
                backgroundColor: "#FFFAEC",
                padding: "8px 16px",
                borderRadius: "20px",
                fontSize: "12px",
                color: "#6C5D3A"
              }}
            >
              {parseRichText(dict["Select at least one Point Layer to filter the objects."][language])}
            </div>

            <div style={{ display: 'flex', flexDirection: "column", gap: "10px" }}>
              <span >{dict["Select Layer"][language]} (Point)</span>
              <Dropdown
                placeholder={dict["Select"][language]}
                filter_on
                is_enable_empty={false}
                onChange={(value) => {
                  enter_id(value);
                }}
              >
                {point_layers?.map((layer) => {
                  return (
                    <option key={layer?.geo_layer?._id} value={layer?.geo_layer?._id}>
                      {layer?.geo_layer?.name}
                    </option>
                  );
                })}
              </Dropdown>
            </div>

            {selected_layers?.length > 0 && <div
              style={{
                display: "flex",
                maxHeight: "100px",
                overflowY: "auto",
                gap: "5px",
                width: "272px",
                flexWrap: "wrap",
              }}
            >
              {
                selected_layers.map(i => (
                  <div
                    key={i.geo_layer._id}
                    className="label_pill"
                    style={{
                      border: "1px solid #ABABAB80",
                      backgroundColor: "#F1F1F1",
                      textWrap: "nowrap",
                    }}
                  >
                    <span
                      style={{
                        maxWidth: "220px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {i.geo_layer?.name}
                    </span>
                    <button
                      className="center_perfect"
                      onClick={() => enter_id(i.geo_layer._id)}
                      style={{
                        borderRadius: "100%",
                        border: "1px solid black",
                        width: "14px",
                        height: "14px",
                      }}>
                      <Close style={{ width: "10px", height: "10px" }} />
                    </button>
                  </div>
                ))
              }
            </div>}
          </>}

        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Results"][language]}</span>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {dict["Calculate the travel route and distance from the start point to the destination based on the selected path or network."][language]}
          </p>
        </div>
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "20px 0px 15px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            margin: "0px 27px 0px 27px",
          }}
        >
          <label
            style={{ fontWeight: 700, fontSize: "0.875rem", color: "#B2B2B2" }}
          >
            {dict["Table"][language]}
          </label>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "10px",
            margin: "0 27px 0px 27px",
          }}
        >
          <SolidCheckbox
            id="select_all"
            checked={selected_all}
            onChange={() => on_select_all()}
            style={{ width: "18px", height: "18px", cursor: "pointer" }}
          />
          <label
            htmlFor="select_all"
            style={{ fontSize: "14px", cursor: "pointer" }}
          >
            {dict["Select All"][language]}
          </label>
        </div>

        {features.length > 0 && mode_toolbox !== "grouping" && (
          <div
            style={{ maxHeight: "200px", overflowY: "auto", position: "relative" }}
          >
            <table className="toolbox_table">
              <thead>
                <tr>
                  <th>{dict["Select"][language]}</th>
                  <th>No.</th>
                  <th>ID Tool</th>
                  <th>{dict["Duration"][language]}</th>
                  <th>{dict["Action"][language]}</th>
                  {
                    fields.map(field => (
                      <th
                        key={field.key}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {field.name}</th>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {features.map((item, idx) => {
                  const viewStatus = visible_features.includes(item.properties.uuid);

                  let icon_color = "#b7b7b7"
                  let background_color = "white"
                  let color = "black";
                  if (item.properties.uuid === routing_active_uuid) {
                    background_color = "#ABABAB80";
                  } else if (last_saved_feature_uuid_index < idx) background_color = "lightGrey";

                  if (viewStatus) icon_color = "black";

                  return (
                    <React.Fragment key={idx}>
                      <tr
                        style={{ backgroundColor: background_color, color: color }}
                        onClick={() => fly_to(item.properties.uuid)}
                      >
                        <td style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "center" }}>
                          <SolidCheckbox
                            checked={selected_row_toolbox_ids.includes(
                              item.properties.uuid,
                            )}
                            onChange={() => {
                              on_select_row_uuid(item.properties.uuid)
                            }}
                            style={{ width: "18px", height: "18px" }}
                          />
                          <button
                            style={{ color, borderRadius: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}
                            onClick={() => on_hide(item.properties.uuid)}
                          >
                            <ICON_VIEW
                              color={icon_color}
                              strokeWidth={viewStatus ? 4 : 3}
                              style={{ width: "18px", height: "18px" }}
                            />
                          </button>
                        </td>

                        <td style={{ color }}>{idx + 1}</td>
                        <td style={{ color }}>{item?.properties?.id_tool}</td>
                        <td style={{ color }}>{item?.properties?.duration_sec ? format_time(item?.properties?.duration_sec) : "-"}</td>
                        <td>
                          <button
                            className="noselect"
                            style={{ borderRadius: "5px", padding: "2px", color }}
                            onClick={() => on_edit(item.properties.uuid)}
                          >
                            Edit
                          </button>
                        </td>
                        {
                          fields.map(field => (
                            <td
                              key={`${field.key}_${item?.properties?.uuid}`}
                              style={{
                                maxWidth: "100px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                color
                              }}
                            >{item?.properties?.[field.name]}</td>
                          ))
                        }

                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {selected_row_toolbox_ids?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <button
              onClick={() => on_clear_select()}
              className="button_pill button_white"
            >
              {dict["Cancel"][language]}
            </button>

            <button
              onClick={() => set_modal_delete(true)}
              className="button_pill flex"
              style={{
                backgroundColor: "#BD0000",
                color: "white",
              }}
            >
              <img src={icon_trash} alt="Delete" />
              {dict["Delete"][language]}
            </button>
            <button
              onClick={() => set_modal_save_tool(true)}
              title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Routes"][language]}`}
              className="button_pill flex"
              style={{
                backgroundColor: "black",
                color: "white",
              }}
            >
              {dict["Save"][language]}
            </button>
          </div>
        )}
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "25px 27px 0px 27px",
        }}
      >
        <div
          style={{
            border: "1px solid #D3B572",
            backgroundColor: "#FFFAEC",
            padding: "8px 16px",
            borderRadius: "20px",
            fontSize: "12px",
            marginBottom: "20px",
            color: "#6C5D3A"
          }}
        >
          {parseRichText(dict["Select at least one Point Layer to filter the objects."][language])}
        </div>

      </section>


      {modal_delete_content}
      {modal_save_content}
      {modal_mapid_data_content}
      {/* {modal_save_poi_content} */}
    </>
  );
}

export default TOOLBOX_DETAIL_ROUTING;